exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag {\n  display: grid;\n  height: 48px;\n  align-items: center;\n  justify-items: self-start;\n  grid-column-gap: 15px;\n  border-bottom: 1px solid #eee;\n  padding: 5px;\n}\n.tag * {\n  user-select: none;\n}\n.tag:not(.inline-operator) {\n  grid-template-columns: 1fr max-content max-content;\n}\n.tag.inline-operator {\n  padding: 5px 10px;\n}\n.tag:hover,\n.tag.selected {\n  background-color: #f9f9f9;\n  cursor: pointer;\n}\n.tag:last-child {\n  border-bottom: none;\n}\n", ""]);

// exports
